'use client';

import IconArrowDown from '@assets/icons/IconArrowDown';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import IconVnFlag from '@/components/icons/vn-flag';
import { appLanguages } from '@/utils/config/app';
import { getLocaleCookie } from '@/utils/functions';
import Popover from '../popover';
const LanguagePopover = () => {
  const router = useRouter();
  const [currentLng, setCurrentLng] = useState({
    name: 'Vietnamese (vi-VN)',
    label: 'VN',
    value: 'vi',
    icon: <IconVnFlag width={18} />
  });
  const changeLanguage = (lng: string) => {
    if (typeof document !== 'undefined') {
      document.cookie = `NEXT_LOCALE=${lng}; Path=/`;
      setCurrentLng(appLanguages.find(item => item.value === lng));
      router.refresh();
    }
  };
  useEffect(() => {
    const lng = getLocaleCookie();
    if (lng) setCurrentLng(appLanguages.find(item => item.value === lng));
  }, []);
  return <Popover content={<div className='flex min-w-[200px] flex-col gap-2 py-2'>
          <div>
            <p className='text-sm font-bold'>Languages</p>
          </div>
          {appLanguages.map(lng => <div key={lng.value} onClick={() => changeLanguage(lng.value)} className={`flex cursor-pointer items-center gap-2 rounded-lg p-2.5 font-medium hover:bg-default-100 ${currentLng?.value === lng.value ? 'bg-default-100' : ''}`}>
              {lng.icon}
              <span>{lng.name}</span>
            </div>)}
        </div>} placement='bottom' data-sentry-element="Popover" data-sentry-component="LanguagePopover" data-sentry-source-file="index.tsx">
      <div className={`flex cursor-pointer items-center gap-2 rounded-lg bg-[#F1F5Fa] px-3 py-2.5 text-[13px] font-medium`}>
        <div className='flex items-center gap-1'>
          {currentLng?.icon}
          {currentLng?.label}
        </div>
        <IconArrowDown width={18} data-sentry-element="IconArrowDown" data-sentry-source-file="index.tsx" />
      </div>
    </Popover>;
};
export default LanguagePopover;